// Module
var code = "<div class=\"{{ ::$ctrl.customClass }}\" ng-transclude></div> ";
// Exports
export default code;